export const DEFAULT_PROMPT_PACK_SIZE = 72;
export const AUTOMOTIVE_PROMPT_PACK_SIZE = 84;

const AUTOMOTIVE_CATEGORY_KEYS = new Set([
  "automotive_dealership",
  "automotive_dealer",
  "auto_dealer"
]);

function normalizeCategoryKey(value?: string | null) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function getDesiredPromptCount(category?: string | null) {
  const normalizedCategory = normalizeCategoryKey(category);

  if (AUTOMOTIVE_CATEGORY_KEYS.has(normalizedCategory)) {
    return AUTOMOTIVE_PROMPT_PACK_SIZE;
  }

  return DEFAULT_PROMPT_PACK_SIZE;
}
